module.exports = __webpack_public_path__ + "assets/img/1004.bd8fdf46.svg";